module.exports = __webpack_public_path__ + "resources/img/logo_nhn_cloud_color_ngsc.e00bdc85f8d46f226c3a3581bc4d0411.svg";